<template>
     <span v-if="$wait.is(name) || icon"  :class="[cls || 'icon']">
       <span v-if="$wait.is(name)" class="spinner-border spinner-border-sm" role="status">
         <span class="sr-only"></span>
       </span>

       <i v-if="!$wait.is(name) && icon" :class="['fi', icon]"></i>
   </span>
</template>

<script>
export default {
    name: "WaitingIndicatorIcon",

    props: {
        name: {
            required: true,
            type: String
        },
        icon: {
            required: false,
            type: String
        },
        color: {
            required: true,
            type: String
        },
        cls: String,
        size: Number
    },
    data() {
        return {
            colours: {
                primary: '#7D6AC8',
                success: '#52C794',
                'dark-green': '#267352',
                blue: '#5276E0',
                secondary: '#FFC480',
                warning: '#FFEB7F',
                orange: '#FFC480',
                danger: '#D32F2F',
                red: '#D32F2F',
                pink: '#FF67A3',
                info: '#69C9E2',
                cyan: '#69C9E2'
            },
        }
    }
}
</script>
